/* eslint-disable no-undef */
const SizeData = ` 11" X 14":Unframed and shipped flat
12" X 16":Unframed and shipped flat
16" X 20":Unframed and shipped flat
16" X 23":Unframed and shipped flat
16.5" X 23":Unframed and shipped flat
17" X 22":Unframed and shipped flat
19" X 23":Unframed and shipped flat
20" X 16":Unframed and shipped flat
20" X 24":Unframed and shipped flat
20" X 30":Unframed and shipped rolled
21" X 21":Unframed and shipped flat
22" X 27":Unframed and shipped rolled
24" X 20":Unframed and shipped rolled
24" X 24":Unframed and shipped rolled
24" X 30":Unframed and shipped rolled
24" X 34":Unframed and shipped rolled
24" X 36":Unframed and shipped rolled
30" X 30":Unframed and shipped rolled
30" X 40":Unframed and shipped rolled
30.5" X 44":Unframed and shipped rolled
31" X 34":Unframed and shipped rolled
31" X 44":Unframed and shipped rolled
34" X 34":Unframed and shipped rolled
34" X 40.5":Unframed and shipped rolled
36" X 24":Unframed and shipped rolled
36" X 36":Unframed and shipped rolled
40" X 30":Unframed and shipped rolled
40" X 40":Unframed and shipped rolled
40" X 60":Unframed and shipped rolled
60" X 40":Unframed and shipped rolled
60" X 60":Unframed and shipped rolled
75" X 59":Unframed and shipped rolled `; 

function updateShippingMessage(override = ''){
    var selectedSize = (typeof override !== 'undefined') ?  override : $('#data-variant-option-0').attr('data-variant-option-chosen-value');
    var holder = SizeData.trim();
	var results = [];
    holder.split(/\r?\n/).map(function(item){
        var clean = item.trim();
        var cleanList = clean.split(':');
        results[cleanList[0].toLowerCase()]=cleanList[1];
        return cleanList;
	})
    let sizeMessage = results[selectedSize.toLowerCase()];
    $('#size-message').remove();
    if( typeof sizeMessage !== 'undefined'){
        $('#product-details-list').append(`<li id="size-message">${sizeMessage}</li>`);
    }

    //console.log(handlelize(override))
    if( $('[data-variant-title="'+handlelize(override)+'"]') ){
        const dataObj = $('[data-variant-title="'+handlelize(override)+'"]')
        const varDetails = dataObj.attr('data-variant-details')
        //console.log(varDetails)
        if(varDetails) {
            $('#variant-message').remove();
            $('#product-details-list').prepend(`<li id="variant-message">${varDetails}</li>`);
        }
        
    }
}

function handlelize (str) {

    str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
      .replaceAll("'", '')
      .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
      .replace(/\-\-+/g, '-')	// Replaces multiple hyphens by one hyphen
      .replace(/(^-+|-+$)/g, '') // Remove extra hyphens from beginning or end of the string
      .toLowerCase(); // To lowercase
  
    return str
  };

$(function() {
    if( $('.product--section').length ){
        var thisVal = $('#selected_variant_data').attr('data-selected-variant-data');
        updateShippingMessage(thisVal);
    }

    $('#data-variant-option-0').on('change', function(){
        var thisVal = $(this).val();
        updateShippingMessage(thisVal);
    });

    $('input:radio[name="Size"]').change(function(){
        if (this.checked) {
            var thisVal = $(this).val();
            updateShippingMessage(thisVal);
        }
    });

    //var event = new Event('change');
    //$('input:radio[name="Size"]::first').trigger('click');
});

// handle tabs
$('.tabs-header span').click(function(){
    $('.tabs-header span, #pdp-tabs .tab').removeClass('selected');
    var tab = $(this).attr('data-tab');
    $(this).addClass('selected');
    $("[data-tab-body="+tab+"]").addClass('selected');
});

function debounce(func, timeout = 150){
    let timer;
      return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => { func.apply(this, args); }, timeout);
      }
  }
  
  
  function handleResizes() {
    updatePromoMosiacGrip()
    updateSpotlightGrip()
  }
  
  window.addEventListener('resize', () => {debounce(handleResizes()) });
  

  function updatePromoMosiacGrip(){
      let promoHeight = 0;
      let contentHeight = 0;
  
      //promo block height
      [...document.querySelectorAll('.promo-mosaic--container div.promo-block')].forEach(function(block) {
          block.style.height = 'auto';
      });
  
      // get content height
      [...document.querySelectorAll('.promo-mosaic--container .promo-block--content-wrapper')].forEach(function(block) {
          //console.log('content: '+block.offsetHeight)
          if( block.offsetHeight > contentHeight ){ 
              contentHeight = block.offsetHeight
          }
      });
  
      [...document.querySelectorAll('.promo-mosaic--container div.promo-block')].forEach(function(block) {
          //console.log('promos: '+block.offsetHeight)
          if( block.offsetHeight > promoHeight ){ 
              promoHeight = block.offsetHeight
          }
      });
  
      [...document.querySelectorAll('.promo-mosaic--container div.promo-block')].forEach(function(block) {
          block.style.height = (promoHeight + contentHeight) + 'px'
      });
  }

  function updateSpotlightGrip(){
	let promoHeight = 0;
	let contentHeight = 0;

	//promo block height
	[...document.querySelectorAll('.promo-grid--container .promo-grid__columns--4 .promo-block, .promo-grid--container .promo-grid__columns--4')].forEach(function(block) {
		block.style.height = 'auto';
	});

	// get content height
	[...document.querySelectorAll('.promo-grid--container .promo-grid__columns--4 .promo-block--content')].forEach(function(block) {
		//console.log('content: '+block.offsetHeight)
		if( block.offsetHeight > contentHeight ){ 
			contentHeight = block.offsetHeight
		}
	});

	[...document.querySelectorAll('.promo-grid--container .promo-grid__columns--4 .promo-block')].forEach(function(block) {
		//console.log('promos: '+block.offsetHeight)
		if( block.offsetHeight > promoHeight ){ 
			promoHeight = block.offsetHeight
		}
	});

	[...document.querySelectorAll('.promo-grid--container .promo-grid__columns--4 .promo-block')].forEach(function(block) {
		block.style.height = promoHeight + 'px'
	});

	[...document.querySelectorAll('.promo-grid--container .promo-grid__columns--4')].forEach(function(block) {
		block.style.height = (promoHeight + contentHeight) + 'px'
	});
}




  // handle initial page load
  handleResizes()



var windowHasLoaded = false;
function doSomethingWhenWindowHasLoaded() {
    if (!windowHasLoaded) {
        window.setTimeout(doSomethingWhenWindowHasLoaded, 100);
    } else {
        window.dispatchEvent(new Event('resize'));
    }        
} 

doSomethingWhenWindowHasLoaded()

window.onload = function () {
    windowHasLoaded = true;
}
